/* NOPA cart drawer: add upsell items via AJAX and re-render the drawer. */
(function () {
  if (window.__nopaCartUpsellBound) return;
  window.__nopaCartUpsellBound = true;

  async function renderCart() {
    const drawer = document.querySelector('cart-drawer');
    const bubble = document.getElementById('cart-icon-bubble');
    try {
      const res = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble');
      const data = await res.json();
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ sections: data });
        drawer.classList.remove('is-empty');
      } else {
        const el = document.getElementById('CartDrawer');
        if (el && data['cart-drawer']) {
          const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          const fresh = doc.getElementById('CartDrawer');
          if (fresh) el.innerHTML = fresh.innerHTML;
        }
        if (bubble && data['cart-icon-bubble']) {
          const doc2 = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
          bubble.innerHTML = doc2.getElementById('cart-icon-bubble').innerHTML;
        }
      }
      if (drawer && typeof drawer.open === 'function') drawer.open();
    } catch (e) {}
  }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest ? e.target.closest('[data-nopa-cart-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = Number(btn.getAttribute('data-nopa-cart-add'));
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      await renderCart();
    } catch (err) {
      btn.classList.remove('is-loading');
    }
  });
})();
